import actions from "./actions";
import { call, put, takeLatest, fork } from "redux-saga/effects";
import { GET_LIST_WINNER_BY_TYPE, GET_REMAINING } from "./constants";
import { getListWinnerByTypeApi, getRemainingApi } from "api/prize";

export function* getRemainingSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getRemainingApi, payload);
    yield put(actions.GET_REMAINING.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_REMAINING.failure(err));
  }
}

export function* getListWinnerByTypeSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getListWinnerByTypeApi, payload);
    yield put(actions.GET_LIST_WINNER_BY_TYPE.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_LIST_WINNER_BY_TYPE.failure(err));
  }
}

function* watchCommon() {
  yield takeLatest(GET_REMAINING.request, getRemainingSaga);
  yield takeLatest(GET_LIST_WINNER_BY_TYPE.request, getListWinnerByTypeSaga);
}

export default function* rootChild() {
  yield fork(watchCommon);
}
